import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentRegistryEditCrumbs } from 'civil-status/constants/document-registry-breadcrumb';
import FormDocumentRegistry, {
  DocumentRegistryForm,
} from 'civil-status/components/document-registry/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { DocumentRegistry } from 'shell/models/document-registry';
import { transformResponseDocumentRegistry } from 'civil-status/utils/transformer-document-registry';

const DocumentRegistryEditPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const updateRegistry = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/registro-atto/aggiorna-registro-atto`,
    {
      options: {
        method: 'PUT',
      },
    }
  );

  const [register] = useHttpFetch<HttpResponse<DocumentRegistry>, DocumentRegistryForm>(
    `${__CIVIL_STATUS_API_URL__}/registro-atto/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseDocumentRegistry,
    }
  );

  const handleSubmit = useCallback(
    (values) => {
      (
        updateRegistry({
          data: {
            key: {
              codiceRegistro: params.id,
            },
            registro: values.description,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/registri');
      });
    },
    [updateRegistry, navigate]
  );

  const isLoading = register.isLoading || register.pristine || register.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={DocumentRegistryEditCrumbs} />
      {!isLoading ? (
        <FormDocumentRegistry
          title={'Modifica Numero Registro'}
          onOk={handleSubmit}
          onCancel={() => {
            navigate('/stato-civile/registri');
          }}
          isEdit
          initialValues={register.data as DocumentRegistryForm}
        ></FormDocumentRegistry>
      ) : undefined}
    </Fragment>
  );
};

DocumentRegistryEditPage.displayName = 'Document Registry Edit page component';

export default DocumentRegistryEditPage;
